import React, { Fragment } from "react";
import { Link } from "react-router";
import Config from "../../../config/main";
import moment from "moment";
import { convertGameStateName } from "../../../helpers/sport/gameTimeNames";
import { additionalMarketsCount } from "../../../helpers/sport/sportData";
import { hasVideo } from "../../../helpers/sport/videoFilter";
import { t } from "../../../helpers/translator";
import Helpers from "../../../helpers/helperFunctions";
import Event from '../event';
import Expandable from "../../containers/expandable";
import BetBuilderIcon from "../../containers/betBuilderWrapper/components/betBuilderIcon";
import _ from "lodash";

export default function standartGameTemplate() {
    let { game, gameType, sportAlias, favoritesGameId, boostedOddsGameIds } = this.props,
        isLive = gameType === "live",
        gameTime = moment.unix(this.props.start_ts).format(Config.main.timeFormat);
    if (boostedOddsGameIds) {
        const boostedGameIds = Config.enableBoostedOdds && Object.keys(boostedOddsGameIds).includes(game.id.toString()) && boostedOddsGameIds[game.id];
        var boostedGameMarketsObject = boostedGameIds && createDynamicObjectFromGameMarketsArray(boostedGameIds);
    }

    return game ? <div key={game.id} className={"single-game-list-item-m " + (game.is_blocked ? "blocked" : "")}>
        {/* <div className={"teams-name-info-m" + (game.team2_name ? "" : " single-team")}> */}
        {
            Config.enableBoostedOdds && boostedOddsGameIds && Object.keys(boostedOddsGameIds).length > 0 && Object.keys(boostedOddsGameIds).includes(game.id) && <span className='boosted'></span>
        }
        <Expandable openAnywhere={true} uiKey={game.id} className={`sport-region-info-m standart-game ${!game.team2_name ? 'one-team' : ''}`}>
            {isLive && <span className="time-view-game-m">
                <b className="b-row-view-m">{t(convertGameStateName(game.info && game.info.current_game_state, this.props.sportAlias))} {game.info && game.info.current_game_time}</b>
            </span>}

            {!isLive && <span className="time-view-game-m">{gameTime}</span>}

            <span className="team-name-m-box">
                <i>{game.team1_name}</i>
            </span>

            {isLive && <span className="game-score-live-m">
                <i className="game-score-v">{game.info && game.info.score1}</i>
                <i className="game-score-v">{game.info && game.info.score2}</i>
            </span>}

            {!isLive && game.team2_name && <span className="vs">vs</span>}

            <span className="team-name-m-box">
                <i>{game.team2_name}</i>
            </span>

            <BetBuilderIcon game={game} />

            {Config.statisticsButton &&
                this.props.game.is_stat_available
                ? <div className="statictic-button-c" onClick={() => { this.upperScreenStatistics(game); }}></div>
                : null}

            {hasVideo(game) && game.is_started && <span className="icons-game-info-m">
                <i className="icon-separator-m video-icon" />
            </span>}

            { !!game.market.length && <b className={`ex-arrow-icon-m`} /> }

            <Link className="markets-count-view-m"
                onClick={() => { sessionStorage.setItem('scrollPos', JSON.stringify({ [history.state.key]: document.getElementById('getScrollPosition').scrollTop })); }}
                to={`/${gameType === "boosted" ? "prematch" : gameType}/${sportAlias}/${game.regionId}/${game.competitionId}/${game.id}`}>
                {additionalMarketsCount(game)}
            </Link>
        </Expandable>
        {
            !!game.market.length && 
            <div className="competition-naw-wrapper-m">
                <div className="competition-list-view-m">
                    <div className="row-view-game-items">
                        {
                            game.market[0] ? Helpers.objectToArray(game.market[0].event).sort((a, b) => a.order - b.order).map((event) => {
                                let name = event.name;
                                switch (event.type) {
                                    case 'P1':
                                        name = game.team1_name;
                                        break;
                                    case 'P2':
                                        name = game.team2_name;
                                        break;
                                    default:
                                        name = event.name;
                                        break;
                                }
                                return <div className="factor-m" key={event.name}>
                                    <Event name={name} event={event} price={event.price} game={game} market={game.market} boostedOdds={boostedGameMarketsObject} standartViewHomePage={true} />
                                </div>;
                            }) : null
                        }
                    </div>
                </div>
            </div>
        }
        {/* <div className="row-view-game-items">
            {
                game.market[0] ? Helpers.objectToArray(game.market[0].event).sort((a, b) => a.order - b.order).map((event) => {
                    let name = event.name;
                    switch (event.type) {
                        case 'P1':
                            name = game.team1_name;
                            break;
                        case 'P2':
                            name = game.team2_name;
                            break;
                        default:
                            name = event.name;
                            break;
                    }
                    return <div className="factor-m" key={event.name}>
                        <Event name={name} event={event} price={event.price} game={game} market={game.market}/>
                    </div>;
                }) : null
            } */}
        {/* {console.log(game.market, "0000000000000000000=-=-=-=-=-=-=-=-=-=")}
            {
                game.market.length ? <div className="competition-list-view-m">
                    <div className="row-view-game-items">
                        {
                            game.market[0] ? Helpers.objectToArray(game.market[0].event).sort((a, b) => a.order - b.order).map((event) => {
                                return <div className="factor-m" key={event.name}>
                                    <Event name={event.name} event={event} price={event.price} game={game} market={game.market}/>
                                </div>;
                            }) : null
                        }
                    </div>
                </div> : null
            } */}
        {/* </div> */}
    </div> : null;
}
function createDynamicObjectFromGameMarketsArray(array) {
    let newObject = {};
    if (array) {
        for (let item of array) {
            var tempObj = {
                ...tempObj,
                [item.Id]: {
                    Id: item.Id,
                    marketId: item.MarketId,
                    name: item.Name,
                    marketName: item.MarketName,
                    MatchId: item.MatchId
                }
            };
            newObject = tempObj;
        }
    }
    return newObject;
}